module.exports = {
	"pagination": {
		"DescribeApplicationVersions": {
			"result_key": "ApplicationVersions"
		},
		"DescribeApplications": {
			"result_key": "Applications"
		},
		"DescribeConfigurationOptions": {
			"result_key": "Options"
		},
		"DescribeEnvironmentManagedActionHistory": {
			"input_token": "NextToken",
			"limit_key": "MaxItems",
			"output_token": "NextToken",
			"result_key": "ManagedActionHistoryItems"
		},
		"DescribeEnvironments": {
			"result_key": "Environments"
		},
		"DescribeEvents": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "Events"
		},
		"ListAvailableSolutionStacks": {
			"result_key": "SolutionStacks"
		},
		"ListPlatformBranches": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken"
		},
		"ListPlatformVersions": {
			"input_token": "NextToken",
			"limit_key": "MaxRecords",
			"output_token": "NextToken",
			"result_key": "PlatformSummaryList"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/elasticbeanstalk-2010-12-01.paginators.json
// module id = 1996
// module chunks = 0